import getSelloutMonitoringRequest from '@domain/model/request/selloutMonitoring/getSelloutMonitoring';
import getSelloutMonitoring from '@hooks/selloutMonitoring/getSelloutMonitoring';

const useGetSelloutMonitoring = (filters) => {
    const { queries, enabled } = getSelloutMonitoringRequest(filters);

    return getSelloutMonitoring({ queries, enabled });
};

export default useGetSelloutMonitoring;
